import styled from "styled-components";
import { Row } from "react-bootstrap";

export const Wrapper = styled(Row)`
  max-width: 700px;
  img {
    max-width: 280px;
  }
  label {
    font-weight: 300;
    font-size: var(--font-size-sm);
    color: var(--text-color-dark);
  }
  option {
    font-size: var(--font-size-xs);
    color: var(--dark-color);
  }
  .number-input {
    height: 40px;
    border: 0.5px solid var(--tertiary-color);
    border-radius: 6px;
    font-size: var(--font-size-xs);
    color: var(--dark-color);
    input:disabled {
      background-color: transparent;
      opacity: 0.7;
    }
  }
  .trash-button {
    background: var(--white-color);
    border: none;
    position: absolute;
    top: 5px;
    left: 5px;
    svg {
      pointer-events: none;
    }
  }
  .trash-skeleton {
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .caption {
    font-weight: 500;
    font-size: var(--font-size-xs);
    color: var(--blue-color-dark);
  }
`;

export const StyledRow = styled(Row)`
  position: relative;
  min-height: 100px;
  border: 1px solid var(--primary-color);
  border-radius: 8px;

  .before-discount {
    font-size: var(--font-size-sm);
    color: var(--text-color-dark);
  }
  .after-discount {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--text-color-dark);
  }
  .currency-pricean {
    font-size: var(--font-size-sm);
  }
`;
